import {fromEvent, tap} from "rxjs";

export function Modal(modal) {
    if (!modal) {
        throw new Error('Modal instance is null or undefined');
    }

    const instance = modal;

    const closeButton = modal.querySelector('.modal__close-button button');
    if (closeButton) {
        fromEvent(closeButton, 'click')
            .subscribe(() => {
                document.body.style.overflowY = 'initial';
                instance.classList.remove('modal--visible');
            })
    }

    return {
        getInstance: function() {
            return instance;
        },
        isVisible: function() {
            return instance && instance.classList.contains('modal--visible');
        },
        show: function() {
            document.body.style.overflowY = 'hidden';
            instance.classList.add('modal--visible');
        },
        hide: function() {
            document.body.style.overflowY = 'initial';
            instance.classList.remove('modal--visible');
        }
    }
}
